import { api } from '../client/client.js';
import { formatDate, mapServerStatus } from '../format/format.js';

export function listServers({ search } = {}) {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  const qs = params.toString();
  return api.get(`/servers${qs ? `?${qs}` : ''}`).then((servers) =>
    servers.map((s) => ({
      id: s.id,
      name: s.name,
      owner: s.owner || '—',
      provider: s.provider || '—',
      providerId: s.provider_id || '—',
      plan: s.plan || '—',
      location: s.location || '—',
      ip: s.ip || '—',
      os: s.os || '—',
      status: mapServerStatus(s.status),
      cpu: s.cpu || 0,
      ram: s.ram || 0,
      created: formatDate(s.created_at),
      expires: formatDate(s.expires_at),
      autoRenew: !!s.auto_renew,
      paid: Number(s.paid) || 0,
      cost: Number(s.cost) || 0,
    })),
  );
}

export function getServer(id) {
  return api.get(`/servers/${id}`).then((s) => ({
    ...s,
    status: mapServerStatus(s.status),
    provider: s.provider || '—',
    providerId: s.provider_id || '—',
    cpu_type: s.cpu_type || '—',
    created: formatDate(s.created_at),
    expires: formatDate(s.expires_at),
    paid: Number(s.paid) || 0,
    cost: Number(s.cost) || 0,
  }));
}

export function deleteServer(id) {
  return api.delete(`/servers/${id}`);
}
